import React from 'react';
import { connect } from 'react-redux';
import { Input,  message } from 'antd';
import UploadWall from "../../../../components/upload/UploadWall";
import ChunkUpload from '../../../../components/upload/ChunkUpload';
import {checkFileStatus} from "../../../../actions/upload";
import { PIC_TYPE, VIDEO_TYPE, AUDIO_TYPE, ATTCHMENT_TYPE, FILE_TYPE } from "../../../../constants";
import Scrollbars from 'react-custom-scrollbars';
import {applicationName} from "../../../../utils";

const { TextArea } = Input
const Steps1 = (props) => {

    const handleChangeFileList = ({ file, fileList }) => {
            if(file.status === "done") {
                checkStatus(file.response.storageFile.md5, (stateStr)=>{
                    let newFileList = fileList.map(item=>{
                        if(item.uid === file.uid){
                            item.url = "";
                            item.path = file.response.url;
                            item.ingStatus = stateStr;
                        }
                        return item;
                    });
                    props.changeProjectAttachment(newFileList)
                },(response)=>{
                    file.response = response;
                    saveFile(file).then(res=>{
                        let newFileList = fileList.map(item=>{
                            if(item.uid === file.uid){
                                item.url = "images/file.png";
                                item.path = file.response.url;
                                item.resourceId = res.resourceId;
                                item.icon = <img src={"images/file.png"} width={70} height={90} alt=""/>;
                            }
                            return item;
                        });
                        props.changeProjectAttachment(newFileList)
                    }).catch(err=>{
                        message.error("附件存放媒资库中出错");
                    });
                });
            }
            props.changeProjectAttachment(fileList)
        };
    
    const saveFile = (file) => {
            let result = file.response;
            let url;
            let fileTemp = {};
            let params = {};
            let files=[];
            fileTemp.dataSource = 4;
            fileTemp.name = result.storageFile.name;
            fileTemp.ext = result.storageFile.suffix;
            fileTemp.path = result.url;
            fileTemp.size = result.storageFile.size ? result.storageFile.size : file.size;
            fileTemp.storyId = 0;
            fileTemp.md5 = result.storageFile.md5;
            fileTemp.publish=0;
            params.dataSource = 4;
            if(PIC_TYPE.indexOf(result.storageFile.suffix) !== -1){
                url = "/cm-sites-pms/v3/zyk/savePicture";
                fileTemp.imageHeight = result.storageFile.height;
                fileTemp.imageWidth = result.storageFile.width;
                files.push(fileTemp);
                params.pictures=files;
            }else if(VIDEO_TYPE.indexOf(result.storageFile.suffix) !== -1){
                url = "/cm-sites-pms/v3/zyk/saveVideo";
                fileTemp.frameHeight = result.storageFile.height;
                fileTemp.frameWidth = result.storageFile.width;
                fileTemp.allTime = result.storageFile.duration;
                files.push(fileTemp);
                params.videos=files;
            }else if(AUDIO_TYPE.indexOf(result.storageFile.suffix) !== -1){
                url = "/cm-sites-pms/v3/zyk/saveAudio";
                fileTemp.allTime = result.storageFile.duration;
                files.push(fileTemp);
                params.audios=files;
            }else if(ATTCHMENT_TYPE.indexOf(result.storageFile.suffix) !== -1){
                url = "/cm-sites-pms/v3/zyk/saveOtherFile";
                files.push(fileTemp);
                params.otherFiles=files;
            }
            return new Promise((resolve, reject) => {
                window.$.ajax({
                    type: "post",
                    url: url,
                    cache: false,
                    // async: false,
                    data: JSON.stringify(params),
                    dataType: "json",
                    contentType: 'application/json;charset=UTF-8',
                    success: function (res) {
                        let data;
                        if(res.data){
                            data=JSON.parse(res.data);
                            resolve(data&&data.length&&data[0]);
                        }
                    },error: function (err) {
                        console.log("err:    ", err);
                        reject(err);
                    }
                });
            });
    }

    const handleRemove =  file => {
        let fileList1 = props.projectAttachment.filter(item => { return item.uid !== file.uid })
        props.changeProjectAttachment(fileList1)
    };

        //检查上传之后的状态，视频有的时候需要查看是否合并完成了
    const checkStatus = (md5, ingCallBack, overCallBack) => {
            setTimeout(()=>{
                checkFileStatus(md5).then(res=>{
                    if(res.state !== "mergeComplete"){
                        checkStatus(md5, ingCallBack, overCallBack);
                        ingCallBack(res.stateStr);
                    }else{
                        overCallBack(res);
                    }
                }).catch(()=>{
                    overCallBack({});
                });
            }, 100);//每隔一秒钟进行检查一次
        }
    

    const { projectName, projectCreater, projectContent, changeProjectName, changeProjectCreater, changeProjectContent, projectAttachment } = props;


    return (
        <Scrollbars>
            <div className="steps1">
                <div className="first">
                    <div>
                        <span className="required">项目名称</span>
                        <Input value={projectName} onChange={(e) => changeProjectName(e.target.value)} maxLength={200}/>
                    </div>
                    <div>
                        <span>项目负责人</span>
                        <Input value={projectCreater} onChange={(e) => changeProjectCreater(e.target.value)} maxLength={20}/>
                    </div>
                </div>
                <div className="second">
                    <span className="required">项目内容</span>
                    <TextArea rows={10} value={projectContent} onChange={(e) => changeProjectContent(e.target.value)} />
                </div>
                <div className="thrid">
                    <span>附件</span>
                    <div className="thrid">
                    </div>
                    <UploadWall
                    accept={"."+FILE_TYPE.join(",.")}
                    multiple={true}
                    action="/cm-sites-pms/index/uploadFile"
                    listType="picture-card"
                    fileList={projectAttachment}
                    customRequest={new ChunkUpload({
                        checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                        checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                        uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                        chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                        mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                    }).start}
                    icons={["download", "delete"]}
                    uploadBtnName={"上传附件"}
                    onChange={handleChangeFileList}
                    onRemove={handleRemove}
                    listType={"list"}
                    onDownload={(file)=>{
                        if(file.path.indexOf("?") === -1){
                            window.location.href = file.path + "?download=1";
                        }else{
                            window.location.href = file.path + "&download=1";
                        }
                    }}
                />
                </div>
            </div>
        </Scrollbars>
    )
}

const mapStateToProps = (state) => {
    return {
        projectName: state.projectReducer.projectName,
        projectCreater: state.projectReducer.projectCreater,
        projectContent: state.projectReducer.projectContent,
        projectAttachment: state.projectReducer.projectAttachment
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeProjectName: (value) => dispatch({ type: 'CHANGE_PROJECT_NAME', payload: value }),
        changeProjectCreater: (value) => dispatch({ type: 'CHANGE_PROJECT_CREATER', payload: value }),
        changeProjectContent: (value) => dispatch({ type: 'CHANGE_PROJECT_CONTENT', payload: value }),
        changeProjectAttachment: (value) => dispatch({ type: 'CHANGE_PROJECT_ATTACHMENT', payload:value})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Steps1)